export default "__VITE_ASSET__Cgq0qb6O__"